import React from 'react';
import { Dropdown } from 'primereact/dropdown';

import { MessageStatus } from 'common/dropdownOptions';
import { useFileManagerContext } from 'modules/FileManagerV2/context/FileManagerContext';

function FileStatusFilter() {
  const { fileManagerFilters, onFilterChange, setSelectedRows, isContentSearchActive, isCaseFileManager, isLeadFileManager } =
    useFileManagerContext();

  const shouldDisable = isContentSearchActive && (isCaseFileManager || isLeadFileManager);

  return (
    <div className="filter-wraper">
      <Dropdown
        options={MessageStatus}
        value={fileManagerFilters?.fileStatus}
        placeholder="By File Status"
        className="file-manager-select col-sm-12"
        onChange={(e) => {
          onFilterChange(e);
          setSelectedRows([]);
        }}
        name="fileStatus"
        disabled={shouldDisable}
      />
    </div>
  );
}

export default FileStatusFilter;
